import { PureComponent } from 'react';

import { Button } from 'components/Button/Button';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import handleEvent from 'utils/handleEvent';

export default class AddRow extends PureComponent {
  static propTypes = {
    msg: PropTypes.object.isRequired,
    noRows: PropTypes.bool,
    onAddRow: PropTypes.func.isRequired,
    rowIndex: PropTypes.number.isRequired,
  };

  static defaultProps = {
    noRows: false,
  };

  handleAddRow = handleEvent(() => {
    const { onAddRow, rowIndex } = this.props;
    onAddRow(rowIndex);
  });

  render() {
    const { msg } = this.props;
    return (
      <div className='row'>
        <div className='col-xs-12 text-center'>
          <div onClick={this.handleAddRow} className='dazzle__add-row-wrapper'>
            <Button
              accent='positive'
              className='h-full w-full'
              icon='fa-plus'
              variant='tertiary'
            >
              {get(msg, ['dazzle', 'addRow'])}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
